'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _Notification = require('./Notification');

var _Notification2 = _interopRequireDefault(_Notification);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Notification2.default;


//////////////////
// WEBPACK FOOTER
// ./~/@surfline/quiver-react/dist/Notification/index.js
// module id = 174
// module chunks = 0